export default "__VITE_ASSET__Dmu3U_6K__"